import * as React from 'react'

type Resolution = 'extra-low' | 'low' | 'slightly-low' | 'normal' | 'hi'

export type Props = {
  src: string
  res?: Resolution
} & React.ImgHTMLAttributes<HTMLImageElement>

export const fromContentful = (src: string) =>
  src.includes('//images.ctfassets.net/')

export const params = (w: number) => `w=${w}`

export const toSize = (res?: Resolution) => {
  switch (res) {
    case 'hi':
      return 840
    case 'slightly-low':
      return 480
    case 'low':
      return 320
    case 'extra-low':
      return 160
  }
  return 720 // normal
}

export const createOptimizedUrl = () => {
  return (src: string, res?: Resolution) => `${src}?${params(toSize(res))}`
}

export const ContentfulResizedImage: React.FC<Props> = (props) => {
  if (!fromContentful(props.src)) {
    return <img {...props} />
  }
  return <img {...props} src={`${props.src}?${params(toSize(props.res))}`} />
}

// NOTE: Breakpoint 420px for Xperia 1 (viewport width 418px, 2px for safe margin)
export const ContentfulResponsiveImage: React.FC<Props> = (props) => {
  if (!fromContentful(props.src)) {
    return <img {...props} />
  }
  return (
    <picture>
      <source
        srcSet={`${props.src}?${params(toSize(props.res))}`}
        media="(max-width: 420px)"
      />
      <source srcSet={`${props.src}?${params(1280)}`} />
      <img {...props} src={`${props.src}?${params(1280)}`} />
    </picture>
  )
}
